export interface IMicrositeRecipientRequest {
    id: number,
    shortCode: string,
    editKey: string,
    centerId: number,
    campaignId: number,
    coordinatorContactId: number,
    secondaryCoordinatorContactId: number,
    phonePrimary: string,
    phoneSecondary: string,
    coachContactId: number,
    email: string,
    secondaryEmail: string,
    firstName: string,
    lastName: string,
    currentStatusId: number,
    isDeleted: boolean,
    isTestSite: boolean,
    addressLine1: string,
    addressLine2: string,
    city: string,
    stateId: number,
    postalCode: string,
    birthdate: string,
    genderId: number,
    languagePreferenceId: number,
    aboTypeId: number,
    isResponsibilityConfirmed: boolean,
    isPatientUpdateEnabled: boolean,
    transplantDate: string,
    donorOrigin: number,
    transplantedFromDashRegistration: boolean,
    dashRegistrationId: number,
    reason: string,
    micrositeTypeId: number,
    isConfirm: boolean,
    isCoachingDesired: boolean,
    guardianEmail: string,
    guardianFirstName: string,
    guardianLastName: string,
    guardianPhone: string,
    isVeteran: boolean | null,
    branchOfService: number,
    hasChampion: boolean,
    championName: string,
    championEmail: string,
    championPhone: string
}